import React from 'react';
import Select from 'react-select';
import theme from 'src/lib/theme';

const getRegions = () => {
	const serverHosts = {
		'http://localhost:3030': 'dev',
		'https://dev-api.wiselysoftware.com': 'dev',
		'https://staging-api.wiselysoftware.com': 'staging',
	};
	const origins = {
		'http://localhost:3000': 'dev',
		'https://dev.wiselysoftware.com': 'dev',
		'https://staging.wiselysoftware.com': 'staging',
	};
	const env = serverHosts[process.env.REACT_APP_API_HOST] || origins[window.location.origin];
	const regions = ['Canada', 'United States of America', 'Other'];

	if (env === 'dev' || env === 'staging') {
		return [env, ...regions];
	}

	return regions;
};

const signupSelectStyles = {
	indicatorSeparator: base => ({ ...base, display: 'none' }),
	placeholder: base => ({
		...base,
		color: 'rgb(117, 117, 117)',
		fontFamily: 'Arial',
		fontStretch: '100%',
		fontWeight: '400',
		lineHeight: 'normal',
	}),
	control: base => ({
		...base,
		padding: '4px',
		border: 0,
		boxShadow: 0,
		color: theme.colors.riverBed,
		fontSize: '16px',
		background: theme.colors['alicia-blue'],
		width: '100%',
		height: '44px',
		borderRadius: '4px',
		marginBottom: '15px',
		marginRight: '15px',
		cursor: 'text',
	}),
	option: (base, { isFocused }) => ({
		...base,
		border: 0,
		boxShadow: 0,
		background: isFocused ? theme.colors.lavender : 'white',
		color: isFocused ? theme.colors.cornflower : theme.colors['very-cool-grey'],
		width: '100%',
		borderRadius: '4px',
		marginRight: '15px',
		cursor: 'pointer',
	}),
	input: base => ({ ...base, color: theme.colors.riverBed }),
	singleValue: base => ({ ...base, color: theme.colors.riverBed }),
};

class RegionSelect extends React.Component {
	createLabels = regions => {
		return regions.map(region => ({ value: region, label: region }));
	};

	applyToValue = onChange => {
		return option => onChange(option.value);
	};

	render() {
		const { onChange, value } = this.props;
		const regions = getRegions();
		const formattedValue = value ? { value: value, label: value } : null;
		return (
			<Select
				placeholder="Country"
				value={formattedValue}
				styles={signupSelectStyles}
				options={this.createLabels(regions)}
				onChange={this.applyToValue(onChange)}
			/>
		);
	}
}

export default RegionSelect;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Signup/RegionSelect/index.js